<template>
  <hm-content title="导购积分奖励列表">
    <div class="table-panel flex item-center">
      <el-input
        clearable
        v-model.trim="guiderKey"
        placeholder="输入导购姓名/手机号"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button type="success" size="small" @click="output">导出</el-button>
    </div>
    <div class="order-list table">
      <el-table
        stripe
        border
        :data="guiderReward.records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="导购姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="workNum"
          label="导购工号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totIntegral"
          label="积分奖励"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="wakeNum"
          label="唤醒会员总数"
        ></el-table-column>
        <el-table-column label="操作" width="50">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
               
              content="积分明细"
              placement="top"
            >
              <div class="pointer mr10" @click="toDetails(scope.row.guiderId)">
                <span class="hmicon icon-chakan blue"></span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="guiderReward.total"
        @current-change="paging"
        layout="total,sizes,   prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
 
 import { mapGetters } from "vuex";

export default {
    
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      guiderKey: "",
      isOutputing: false
    };
  },
  mounted() {
    this.queryList();
  },
  computed: mapGetters(["guiderReward", "allGuiderRewardList"]),
  methods: {
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    queryList() {
      this.$store.dispatch("queryGuiderRewardList", {
        guiderKey: this.guiderKey,
        pageNo: this.currentPage,
        pageSize: this.pageSize
      });
    },
    queryAllList() {
      return this.$store.dispatch("queryAllGuiderRewardList", {
        guiderKey: this.guiderKey,
        pageNo: this.currentPage,
        pageSize: 999999
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    toDetails(guiderId) {
      this.$router.push({
        name: "GuiderRewardDetails",
        query: {
          guiderId
        }
      });
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(() => {
            const list = this.allGuiderRewardList;
            const tHeader = [
              "导购姓名",
              "导购工号",
              "积分奖励",
              "唤醒会员总数"
            ];
            const filterVal = ["name", "workNum", "totIntegral", "wakeNum"];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(tHeader, data, "导购积分奖励列表");
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>

<style scoped lang="scss">
.order-detail-list {
  li {
    margin-bottom: 30px;
    font-size: 14px;
  }
  .title {
    font-size: 16px;
    margin: 0;
    margin-bottom: 10px;
  }
  .item {
    line-height: 28px;
    span {
      color: #999;
    }
  }
  .order-table {
    border: 1px solid #ebebeb;
    margin-top: 12px;
    max-width: 500px;
    .order-header {
      border-bottom: 1px solid #ebebeb;
      background: #f5f7fa;
    }
    span {
      padding: 12px;
      width: 25%;
      text-align: center;
      border-right: 1px solid #ebebeb;
    }
    span:last-child {
      border-right: none;
    }
  }
}
</style>
